import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root')
function HolidayReasonPopup(props) {
    const [isModalOpen, setModalOpen] = useState(false);
    const [holidayReason, setHolidayReason] = useState("");
    const [error, setError] = useState({});
    useEffect(() => {
        setModalOpen(props.modelOpen);
    }, [props]);

    const closeModal = () => {
        props.updateHolidayReason(holidayReason.length > 40 ? "" : holidayReason)
        setModalOpen(false);
        setHolidayReason("")
        setError({});
        props.closeModel();
    }

    const cancelHandle = (event) => {
        props.updateHolidayReason("")
        setModalOpen(false);
        setHolidayReason("")
        setError({});
        props.closeModel();
    }

    const submitHandler = (event) => {
        event.preventDefault();
        if (holidayReason.length > 40) {
            setError({
                characterLimitError: "Please enter a reason containing fewer than 40 characters."
            })
        }
        else {
            props.updateHolidayReason(holidayReason)
            setModalOpen(false);
            setHolidayReason("")
            setError({});
            props.closeModel();
        }
    }

    const changeHolidayReason = (event) => {
        setHolidayReason(event.target.value)
    }

    return (
        <>
            <Modal isOpen={isModalOpen} onRequestClose={closeModal} className="program-modal holiday-modal" overlayClassName="program-modal-overlay">
                <div className="program-modal-container job-disabled-width partner-modal-div program-modal-div" role="document">
                    <div className="program-modal-inner-div error-modal-inner-div">
                        <h4 className="import-error-heading text-color-black">Holiday Reason</h4>
                        {/* <div className='row'> */}
                        <div className="col-md-12 pt-4">
                            <div className="form-wrap">
                                <label className="form-label-outside" htmlFor="general-information-skills">Please Enter Holiday Reason</label>
                                <div className="form-wrap-inner">
                                    <textarea
                                        className="form-input width-100"
                                        placeholder={`E.g., Republic Day`}
                                        value={holidayReason}
                                        onChange={changeHolidayReason}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="text-danger error-msg">
                            {error.characterLimitError}
                        </div>
                        {/* </div> */}
                    </div>
                    <div className="form-button-div mt-5">
                        <button className="brand-button" onClick={submitHandler}>Submit</button>
                        <button className="button-secondary ml-3" onClick={cancelHandle}>Cancel</button>
                    </div>
                </div>
            </Modal>
        </>
    );

}
export default HolidayReasonPopup;